var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-o enable-page-overlay side-scroll page-header-fixed sidebar-inverse",attrs:{"id":"page-container"}},[_c('side-overlay'),_c('sidebar'),_c('page-header'),_c('main',{attrs:{"id":"main-container"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }